// Cornell's undergraduate majors (#2652). Read on 2026-10-01 from Cornell's
// official Courses of Study (catalog.cornell.edu/programs/, the "Programs by
// College/School" tab): every program with a bachelor's degree (BA, BS, BFA,
// BAR); minors, certificates and graduate degrees left out. Quirks: the
// catalog codes two split programs by college (Earth and Climate Sciences
// "ECSAG-BS" and "ECSEN-BS"; Global & Public Health Sciences "GPHSAG-BS" and
// "GPHSHE-BS"); they show here as BS under the college that lists them. The
// by-college tab has no group for the ILR School, so its one major comes
// from its own program page. A major offered by two colleges is listed under
// each. Flags and the engineering note quote Cornell Admissions' college
// pages (the college file's prog* sources). Zero-width spaces in the catalog
// are removed. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "cornell-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Cornell's official Courses of Study, grouped by the college or school that offers it, with the degree it leads to. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Brooks School of Public Policy",
            "source": {
                "label": "Cornell Courses of Study, Programs by College/School",
                "url": "https://catalog.cornell.edu/programs/"
            },
            "majors": [
                {
                    "name": "Health Care Policy",
                    "degree": "BS"
                },
                {
                    "name": "Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Agriculture and Life Sciences",
            "source": {
                "label": "Cornell Courses of Study, Programs by College/School",
                "url": "https://catalog.cornell.edu/programs/"
            },
            "majors": [
                {
                    "name": "Agricultural Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Animal Science",
                    "degree": "BS"
                },
                {
                    "name": "Applied Economics and Management",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biology & Society",
                    "degree": "BA, BS"
                },
                {
                    "name": "Communication",
                    "degree": "BS"
                },
                {
                    "name": "Earth and Climate Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Entomology",
                    "degree": "BS"
                },
                {
                    "name": "Environment & Sustainability",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Food Science",
                    "degree": "BS"
                },
                {
                    "name": "Global & Public Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Global Development",
                    "degree": "BS"
                },
                {
                    "name": "Information Science",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies in Agriculture & Life Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BS",
                    "flag": "A portfolio is required, due by the application deadline.",
                    "flagSource": "progCALS"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Plant Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Statistics & Biometry",
                    "degree": "BS"
                },
                {
                    "name": "Viticulture and Enology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Architecture, Art and Planning",
            "source": {
                "label": "Cornell Courses of Study, Programs by College/School",
                "url": "https://catalog.cornell.edu/programs/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BAR",
                    "flag": "A portfolio is required, due by the application deadline. Architecture applicants also need 4 units of high school math.",
                    "flagSource": "progAAP"
                },
                {
                    "name": "Fine Arts",
                    "degree": "BFA",
                    "flag": "A portfolio is required, due by the application deadline.",
                    "flagSource": "progAAP"
                },
                {
                    "name": "History of Architecture and Urban Development",
                    "degree": "BS"
                },
                {
                    "name": "Urban and Regional Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Cornell Courses of Study, Programs by College/School",
                "url": "https://catalog.cornell.edu/programs/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Archaeology",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biology & Society",
                    "degree": "BA, BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "China and Asia-Pacific Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "College Scholar",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Earth and Climate Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environment & Sustainability",
                    "degree": "BA"
                },
                {
                    "name": "Feminist, Gender, & Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "Government",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History of Art",
                    "degree": "BA"
                },
                {
                    "name": "Information Science",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latina/o Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Near Eastern Studies",
                    "degree": "BA"
                },
                {
                    "name": "Performing and Media Arts",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Science, Technology and Society",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistical Science",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Duffield College of Engineering",
            "source": {
                "label": "Cornell Courses of Study, Programs by College/School",
                "url": "https://catalog.cornell.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Earth and Climate Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Independent Major",
                    "degree": "BS"
                },
                {
                    "name": "Information Science, Systems, and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Operations Research and Engineering",
                    "degree": "BS"
                }
            ],
            "note": "You start with the common engineering curriculum and apply to affiliate with a major in your second year.",
            "noteSource": "progEng"
        },
        {
            "name": "College of Human Ecology",
            "source": {
                "label": "Cornell Courses of Study, Programs by College/School",
                "url": "https://catalog.cornell.edu/programs/"
            },
            "majors": [
                {
                    "name": "Design and Environmental Analysis",
                    "degree": "BS",
                    "flag": "A design supplement is required, due by the application deadline.",
                    "flagSource": "progHE"
                },
                {
                    "name": "Fashion Design and Management",
                    "degree": "BS",
                    "flag": "A design supplement is required for Fashion Design and Fashion Design Management applicants, due by the application deadline.",
                    "flagSource": "progHE"
                },
                {
                    "name": "Fiber Science",
                    "degree": "BS"
                },
                {
                    "name": "Global & Public Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Human Biology, Health, and Society",
                    "degree": "BS"
                },
                {
                    "name": "Human Development",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "SC Johnson College of Business",
            "source": {
                "label": "Cornell Courses of Study, Programs by College/School",
                "url": "https://catalog.cornell.edu/programs/"
            },
            "majors": [
                {
                    "name": "Applied Economics and Management",
                    "degree": "BS"
                },
                {
                    "name": "Hotel Administration",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Industrial and Labor Relations",
            "source": {
                "label": "Cornell Courses of Study, Industrial and Labor Relations (BS)",
                "url": "https://catalog.cornell.edu/programs/industrial-labor-relations-bs/"
            },
            "majors": [
                {
                    "name": "Industrial and Labor Relations",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
